import { useState } from "react";
import { Plus, Minus } from "lucide-react";

interface FaqItem {
  question: string;
  answer: string;
}

const FaqSection = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const faqs: FaqItem[] = [
    {
      question: "How does music distribution work?",
      answer: "We distribute your music to over 250 streaming platforms worldwide, including Spotify, Apple Music, Amazon, and more. You get full transparency and can monitor your earnings and analytics from your dashboard. Every stream or download generates royalties, paid out to you with no hidden deductions."
    },
    {
      question: "Do I really keep 100% of my ownership?",
      answer: "Yes, with our subscription model, you keep 100% of your ownership of your music. We believe artists should be fairly compensated for their work, which is why we don't take any percentage of your earnings."
    },
    {
      question: "How long does it take for my music to go live?",
      answer: "We deliver your music to all 250+ streaming platforms (DSPs) within 72 hours. Need it faster? With our express add-on service, your release can go live in just 24 hours worldwide. Fast, reliable, and seamless music distribution for artists who don’t want to wait."
    },
    {
      question: "What file formats do you accept?",
      answer: "We accept high-quality WAV files (16-bit or 24-bit, 44.1kHz) for audio tracks. For cover art, we require JPEG or PNG files that are at least 3000x3000 pixels with a square aspect ratio."
    }
  ];

  const toggleFaq = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-black/90">
      <div className="container mx-auto px-">
        <div className="h-px w-full bg-gradient-to-r from-transparent via-ophira-yellow/30 to-transparent mb-8" />
        <div className="text-center mt-16 mb-16">
          <div className="ophira-section-label justify-center">FAQS</div>
          <h2 className="ophira-section-title text-center">Frequently Asked Questions</h2>
          <p className="text-white/65 max-w-2xl mx-auto">
            Find answers to common questions about our music distribution services.
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <div className="border-t border-ophira-darkgray/50">
            {faqs.map((faq, index) => (
              <div key={index} className="py-6 border-b border-ophira-darkgray/50">
                <button 
                  className="w-full flex justify-between items-center text-left"
                  onClick={() => toggleFaq(index)}
                  aria-expanded={activeIndex === index}
                >
                  <h3 className="text-lg md:text-xl font-medium text-white">{faq.question}</h3>
                  {activeIndex === index ? (
                    <Minus size={24} className="text-ophira-yellow flex-shrink-0" />
                  ) : (
                    <Plus size={24} className="text-ophira-yellow flex-shrink-0" />
                  )}
                </button>
                <div 
                  className={`pt-1 md:pt-4 text-white/65 overflow-hidden transition-all duration-300 ${
                    activeIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="text-[14px] pt-1 md:pt-0 md:text-[16px]">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
